import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import type { InvoiceMatchResult } from 'src/utils/paymentsOps/invoiceMatch.types'
import { formatCentsAsUsd } from 'src/utils/invoiceMoney'

interface Props {
  transactionAmount: number
  match: InvoiceMatchResult
}

const verdictCopy = (match: InvoiceMatchResult): string => {
  if (match.kind === 'match') {
    return 'Match — this payment exactly covers the invoice.'
  }

  if (match.kind === 'overfund') {
    return `Overfunds by ${formatCentsAsUsd(match.differenceCents)}.`
  }

  return `Underfunds by ${formatCentsAsUsd(match.differenceCents)}.`
}

const InvoiceMatchPanelComponent = ({ transactionAmount, match }: Props) => {
  return (
    <div
      data-testid="assign-invoice-match"
      css={[
        tw`flex flex-col gap-1 rounded-lg p-3`,
        match.kind === 'match' ? tw`bg-success-200` : tw`bg-warning-100`,
      ]}
    >
      <Typography variant="body2">
        Incoming {formatCentsAsUsd(transactionAmount)} · Invoice remaining{' '}
        {formatCentsAsUsd(match.remainingCents)}
      </Typography>
      <Typography variant="h6">{verdictCopy(match)}</Typography>
    </div>
  )
}

export const InvoiceMatchPanel = memo(InvoiceMatchPanelComponent)
